export const dropDown = () => ({
  margin: "0",
});

export const details = ({ isMobile }) => ({
  variant: isMobile ? "text.copy1Light" : "text.h4Light",
  textTransform: "none",
  margin: "0",
});

export const helpButton = ({ isMobile }) => ({
  variant: isMobile ? "text.copy1Light" : "text.h4Light",

  textTransform: "uppercase",
  color: "primary",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  margin: isMobile ? "0 auto" : "0 10px",

  svg: {
    height: isMobile ? "16px" : "24px",
    width: isMobile ? "16px" : "24px",
    marginRight: "10px",
  },
});
